export default __webpack_public_path__ + "static/media/prodotti-utilitatis.7a800f55.jpg";